// Inspired by https://github.com/paularmstrong/normalizr
// Converts an array of data with IDs to an object with IDs as the keys
// This allows us to do O(1) lookups instead of using something like array.find() to do O(n)
function normalizeData(data, key) {
  const normalizedData = {};
  data.forEach(item => {
    const keyName = item[key];
    normalizedData[keyName] = item;
  });
  return normalizedData;
}

export { normalizeData };
